module.exports = __webpack_public_path__ + "img/Public Bank Enterprise.b129fa8b.png";